import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import UsersAccess from "@/components/settings/UsersAccess";
import Logs from "@/components/settings/Logs";
import ChartDefaults from "@/components/settings/ChartDefaults";
import { DataTab, OrganizationTab, NotificationsTab, MaintenanceTab, PreferencesTab } from "@/components/settings/DataMisc";

const TABS = [
  { key: "organization", label: "Organization", roles: ["super_admin", "admin"] },
  { key: "users", label: "Users & Access", roles: ["super_admin", "admin"] },
  { key: "chart_defaults", label: "Chart Defaults", roles: ["super_admin", "admin", "editor"] },
  { key: "data", label: "Data", roles: ["super_admin", "admin", "editor"] },
  { key: "notifications", label: "Notifications", roles: ["super_admin", "admin"] },
  { key: "logs", label: "Activity Logs", roles: ["super_admin", "admin"] },
  { key: "maintenance", label: "Maintenance", roles: ["super_admin", "admin"] },
  { key: "preferences", label: "Preferences", roles: ["super_admin", "admin", "editor"] },
];

export default function SettingsPage() {
  const { user } = useAuth();
  const visible = TABS.filter((t) => t.roles.includes(user?.role));
  const [tab, setTab] = useState(visible[0]?.key);

  return (
    <div className="h-full overflow-auto" data-testid="settings-page">
      <div className="max-w-7xl mx-auto p-8">
        <h1 className="text-3xl font-black tracking-tight">Settings</h1>
        <div className="mt-5 flex gap-1 border-b border-[#181B34]/10 overflow-x-auto">
          {visible.map((t) => (
            <button key={t.key} data-testid={`settings-tab-${t.key}`} onClick={() => setTab(t.key)}
              className={`px-4 py-2.5 text-sm font-bold whitespace-nowrap border-b-2 -mb-px ${
                tab === t.key ? "border-[#6161FF] text-[#6161FF]" : "border-transparent text-[#676a82] hover:text-[#181B34]"}`}>
              {t.label}
            </button>
          ))}
        </div>
        <div className="mt-7">
          {tab === "organization" && <OrganizationTab />}
          {tab === "users" && <UsersAccess />}
          {tab === "chart_defaults" && <ChartDefaults />}
          {tab === "data" && <DataTab />}
          {tab === "notifications" && <NotificationsTab />}
          {tab === "logs" && <Logs />}
          {tab === "maintenance" && <MaintenanceTab />}
          {tab === "preferences" && <PreferencesTab />}
        </div>
      </div>
    </div>
  );
}
